import { useTranslation } from "react-i18next";
import { LabelsDefaultButtonsProps } from "../../types/labelsDefaultButtonsProps";
import { hideContextMenu } from "../../aplUtils/jqueryHelper";

export default function LabelsDefaultRightClick(props: LabelsDefaultButtonsProps) {
    const { t } = useTranslation();
    if (
        !props.options.labellingOnline &&
        !props.options.labellingOffline &&
        !props.options.workorderEnquiry &&
        !props.options.jobSchedule &&
        !props.options.jobAssign &&
        props.options.jobClose
    )
        return <div id="contextMenu" className="ui-front"></div>;
    else
        return (
            <div id="contextMenu" className="ui-front" onClick={hideContextMenu}>
                <ul
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="dropdownMenu"
                    style={{ display: "block", position: "static", marginBottom: "5px" }}
                >
                    {props.options.labellingOnline ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.labellingOnlineFunc}>
                                {t("main.printScreen")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.labellingOffline ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.labellingOfflineFunc}>
                                {t("main.offlinePrint")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.workorderEnquiry ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.workorderEnquiryFunc}>
                                {t("main.rxg_Work_Order_Enquiry")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.jobSchedule ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.jobScheduleFunc}>
                                {t("main.scheduleWorkOrder")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.jobAssign ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.jobAssignFunc}>
                                {t("main.assign")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.jobClose ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.jobCloseFunc}>
                                {t("main.changeCloseJob")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                </ul>
            </div>
        );
}
